/**
 * Flavor Nutrition Tabs — click sur un tab rond → switch le panel actif.
 */
(function () {
  function init(container) {
    if (container.dataset.fnInit === '1') return;
    container.dataset.fnInit = '1';

    const tabs = [...container.querySelectorAll('[data-tab-index]')];
    const panels = [...container.querySelectorAll('[data-panel-index]')];
    if (!tabs.length || !panels.length) return;

    const setActive = (index) => {
      tabs.forEach((t, i) => {
        const active = i === index;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((p, i) => p.classList.toggle('is-active', i === index));
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => setActive(i));
    });
  }

  function boot() {
    document.querySelectorAll('[data-flavor-nutri]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
